export default "__VITE_PUBLIC_ASSET__202e723b__"